import React from 'react'

import { cn } from '@/lib/utils'

export function MobileCard({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return <div className={cn('mobile-app__card', className)}>{children}</div>
}
